<app-form-text-input
  [form]="form"
  [formControlSelector]="dobSelector"
  [id]="dobSelector"
  [maxLength]="10"
  [formInputType]="formInputType"
  [isSubmitted]="isSubmitted"
  [customMask]="mask"
  [showInnerErrors]="false"
  [label]="label | transloco"
  [placeholder]="inputPlaceholder"
  (keyup)="setValues()">
  <ng-container errors="errors">
    <ng-container *ngIf="isSubmitted">
      <ng-container *ngIf="showAgeEmptyMessageError; else isBirthDateGreaterByCurrent">
        <ng-container *ngTemplateOutlet="mandatoryValidator"></ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</app-form-text-input>

<ng-template #isBirthDateGreaterByCurrent>
  <ng-container *ngIf="isBirthDateGreaterThanCurrentDate; else invalidValue">
    <ng-container *ngTemplateOutlet="birthDateGreaterThanCurrentDate"></ng-container>
  </ng-container>
</ng-template>

<ng-template #mandatoryValidator>
  <span class="only-error" [ngClass]="addErrorClass(dobSelector)">
    {{ "BOOKING_MODULE.PAX.ERRORS.MANDATORY_FIELD" | transloco }}
  </span>
</ng-template>

<ng-template #invalidValue>
  <ng-container *ngIf="isInvalidDateValue; else birthDateGreaterThanAllowed">
    <span class="only-error" [ngClass]="addErrorClass(dobSelector)">
      {{ "BOOKING_MODULE.INVALID_DATE_VALUE" | transloco }}
    </span>
  </ng-container>
</ng-template>

<ng-template #birthDateGreaterThanCurrentDate>
  <span class="only-error" [ngClass]="addErrorClass(dobSelector)">
    {{ "BOOKING_MODULE.BIRTHDATE_GREATER_CURRENT_DATE" | transloco }}
  </span>
</ng-template>

<ng-template #dateRangeError>
  <span class="only-error" [ngClass]="addErrorClass(dobSelector)" *ngIf="showAgeMessageErrorByAges">
    {{
    ageMessageTranslation
    | transloco: { traveler: traveler, min: min, max: max }
    | capitalize
    }}
  </span>
</ng-template>

<ng-template #birthDateGreaterThanAllowed>
  <ng-container *ngIf="showBirthDateGreaterThanAllowed; else birthDateLesserThanAllowed">
    <span class="only-error" [ngClass]="addErrorClass(dobSelector)">
      {{ "BOOKING_MODULE.BIRTHDATE_GREATER_THAN_ALLOWED" | transloco }}
    </span>
  </ng-container>
</ng-template>

<ng-template #birthDateLesserThanAllowed>
  <ng-container *ngIf="showBirthDateLesserThanAllowed; else dateRangeError">
    <span class="only-error" [ngClass]="addErrorClass(dobSelector)">
      {{ "BOOKING_MODULE.BIRTHDATE_LESSER_THAN_ALLOWED" | transloco }}
    </span>
  </ng-container>
</ng-template>

